//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'


export default {
  props: {
    tab: {
      default: ''
    },
    searchData: {
      default: () => ({})
    },
    pageData: {
      default: () => ({})
    }
  },
  data: function() {
    return {
      search: _.extend({
        orderParams: 'createTime',
        bid: undefined,
        cid: undefined,
        q: undefined,
        status: undefined
      }, this.searchData),
      table: [],
      page: _.extend({
        pageNo: 1,
        pageSize: 20,
        total: 0
      }, this.pageData),
      brandOptions: [],
      categoryOptions: [],
      loading: false
    }
  },
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  watch: {
    tab: {
      handler (val) {
        if (val && val == 'goods') {
          let p1 = new Promise((resolve, reject) => {
            this.$axios.get('/mtea/store/admin/goods/category/list', { params: {} }).then(res => {
              this.categoryOptions = [{categoryId: undefined, name: '全部'}].concat(res)
            }).finally(() => {
              resolve()
            })
          })
          let p2 = new Promise((resolve, reject) => {
            this.$axios.get('/mtea/store/admin/goods/brand/list', { params: {} }).then(res => {
              this.brandOptions = [{brandId: undefined, name: '全部'}].concat(res)
            }).finally(() => {
              resolve()
            })
          })
          Promise.all([p1, p2]).then(() => {
            this.handleLoadTableData()
          })
        }
      },
      immediate: true
    }
  },
  mounted () {
    console.log('query', this.$route.query)

  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({}, this.search, _.pick(this.page, 'pageNo', 'pageSize'))
      // console.log('data', data)
      this.$axios.get('/mtea/store/admin/goods/list', { params: data }).then(res => {
        // console.log('res', res)
        this.page.total = res.total
        this.table = res.records
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
